import type { CoverSheetConfigCard } from '../../types';

export const clientGroupCard = {
  id: 'buySideContacts.clientGroup',
  fields: {},
} satisfies CoverSheetConfigCard;
